"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _Image = _interopRequireDefault(require("../../Image"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../utils");

var _Title = _interopRequireDefault(require("../../Title"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var FlexScenariosCard = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
      banner = props.banner,
      sharp = props.sharp,
      radius = props.radius,
      imageSrc = props.imageSrc,
      onCallbackHandle = props.onCallbackHandle,
      flexTitle = props.flexTitle,
      style = props.style,
      configuration = props.configuration,
      className = props.className,
      onClick = props.onClick,
      generalDescription = props.generalDescription,
      isBorder = props.isBorder,
      restProps = __rest(props, ["icon", "banner", "sharp", "radius", "imageSrc", "onCallbackHandle", "flexTitle", "style", "configuration", "className", "onClick", "generalDescription", "isBorder"]); // 判断是否使用的样式类型 -pc or mobile


  var _a = (0, _react.useState)(true),
      currentClass = _a[0],
      setCurrentClass = _a[1];

  var compatibleArr = configuration;

  if (configuration.length > 4) {
    compatibleArr = configuration && configuration.length % 3 ? __spreadArrays(configuration, new Array(3 - configuration.length % 3).fill({
      supplement: true
    })) : configuration;
  } // 大于4条数据 一行展示3张卡片


  var exceedLen = configuration ? configuration.length > 4 : 0;
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(setCurrentClass);
  }, []); // 一行展示2张卡片时，限制高度

  var numLenTwo = configuration && configuration.length === 2; // 一行展示4张卡片时，限制高度

  var numLenFour = configuration && configuration.length === 4;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-scenarios-card-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-scenarios-card-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: generalDescription
  }), /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('flex-default-scenarios-card-container-children-flex-default-area-card', {
      'flex-default-area-card-pc': currentClass,
      'flex-default-area-card-mo': !currentClass
    }),
    ref: ref
  }, restProps), compatibleArr.map(function (item, index) {
    var source = item.source,
        content = item.content,
        filedVideoList = item.filedVideoList,
        filedVideoBg = item.filedVideoBg,
        supplement = item.supplement,
        title = item.title,
        bottomContent = item.bottomContent;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-default-area-card-container-member flex-default-area-card-container-member-attach', {
        'flex-default-area-card-container-member-attach--status': supplement,
        'flex-default-area-card-container-member-col': exceedLen,
        'border-style': isBorder,
        'flex-default-area-card-container-member-four ': numLenFour,
        'flex-default-area-card-container-member-one': isBorder && (configuration === null || configuration === void 0 ? void 0 : configuration.length) === 1
      }),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "scenarios-card-container"
    }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
      className: 'img-circle-angle-default',
      width: '564',
      height: '317',
      source: source,
      filedVideoList: filedVideoList,
      filedVideoBg: filedVideoBg,
      style: {
        height: 'auto',
        backgroundRepeat: '',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
        borderBottomLeftRadius: (numLenFour || exceedLen || numLenTwo) && isBorder ? '0px' : '4px',
        borderBottomRightRadius: (numLenFour || exceedLen || numLenTwo) && isBorder ? '0px' : '4px'
      },
      record: item || {}
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('scene-article-class-container', {
        'content-one-box': isBorder && (configuration === null || configuration === void 0 ? void 0 : configuration.length) === 1,
        'content-two-box': isBorder && numLenTwo,
        'content-three-box': isBorder && exceedLen,
        'content-four-box': isBorder && numLenFour
      })
    }, title ? /*#__PURE__*/_react["default"].createElement("h3", null, title) : null, /*#__PURE__*/_react["default"].createElement("article", {
      className: (0, _classnames["default"])({
        'content-one': isBorder && (configuration === null || configuration === void 0 ? void 0 : configuration.length) === 1,
        'content-two': isBorder && numLenTwo,
        'content-three': isBorder && exceedLen,
        'content-four': isBorder && numLenFour
      }),
      dangerouslySetInnerHTML: {
        __html: content
      }
    }), bottomContent && /*#__PURE__*/_react["default"].createElement("div", {
      className: "scene-article-class-container-bottom",
      dangerouslySetInnerHTML: {
        __html: bottomContent
      }
    }))));
  }))));
});
FlexScenariosCard.displayName = 'TCIFlexScenariosCard';
var _default = FlexScenariosCard;
exports["default"] = _default;